import { z } from "zod";
import {
  createdSchema,
  errorSchema,
  lastModifiedSchema,
  sluggedIdValidator,
} from "entities/common";

const ScreenDimensionsSchema = z.object({
  width: z.number(),
  height: z.number(),
  aspectRatio: z.number().optional(),
});

// Nullable wherever swagger says so: one image with a missing name must not
// reject the whole library list.
const ClubhouseAdKitImageDtoSchema = z.object({
  id: sluggedIdValidator,
  name: z.string().nullish(),
  fileName: z.string().nullish(),
  imageUrl: z.string().nullish(),
  facilityId: z.string().nullish(),
  description: z.string().nullish(),
  dimensions: ScreenDimensionsSchema.nullish(),
  ...createdSchema,
  ...lastModifiedSchema,
  deleted: z.boolean(),
  whenDeleted: z.string().nullish(),
});

export const ClubhouseAdKitImageSchema = ClubhouseAdKitImageDtoSchema;
export const ClubhouseAdKitImageArraySchema = z.array(
  ClubhouseAdKitImageDtoSchema,
);

const ImageUploadFileSchema = z.object({
  name: z.string().nullish(),
  fileName: z.string().nullish(),
  dimensions: ScreenDimensionsSchema.nullish(),
  imageSizeKB: z.number().nullish(),
});

export const ClubhouseAdKitImagesUploadResponseSchema = z.object({
  uploadedImages: z.array(ClubhouseAdKitImageDtoSchema).nullish(),
  errors: z
    .array(
      z.object({
        request: ImageUploadFileSchema.nullish(),
        reasons: z.array(errorSchema).nullish(),
        message: z.string().nullish(),
        metadata: z.record(z.string(), z.unknown()).nullish(),
      }),
    )
    .nullish(),
});

export type ClubhouseAdKitImageDto = z.infer<typeof ClubhouseAdKitImageSchema>;
export type ClubhouseAdKitImagesUploadResponse = z.infer<
  typeof ClubhouseAdKitImagesUploadResponseSchema
>;
